import { ProductCatalogEmbroideryLocation } from '../../../__generated__/graphql/catalog/graphql'
import { EmbroiderableProductFlatlayImage } from '../../../types/graphql/product'

export function getFlatlayImage({
  defaultFlatlay,
  locationFlatlays,
  location,
}: {
  defaultFlatlay: EmbroiderableProductFlatlayImage | undefined
  locationFlatlays: Array<EmbroiderableProductFlatlayImage> | null | undefined
  location: ProductCatalogEmbroideryLocation | undefined
}): EmbroiderableProductFlatlayImage | undefined {
  const locationalFlatlay = locationFlatlays?.find(
    locationFlatlay => locationFlatlay.location === location
  )
  return locationalFlatlay ?? defaultFlatlay
}
